export default __webpack_public_path__ + "static/media/arrow_right_blue.496617c6.svg";